import { i18n } from '../plugins/vuetify';
import router from '../router/index';

const state = () => ({
    display: false,
    timeout: 0,
    message: 'An error.',
    showSnackbar: false,
    color: 'pink'
});

const getters = {
    getErrorsDisplay: state => {
        return state.display;
    },
    getSnackColorDisplay: state => {
        return state.color;
    }
};

const mutations = {
    displayErrors(state, { statusReq, errno }) {
        // case of non-authentified  users
        if (statusReq === 403 || [4403, 4404, 4407].includes(errno)) {
            router.push('/login/sso');
            return;
        }
        if (!errno) {
            state.message = i18n.t('errors.11');
        } else if (errno === 1301) {
            if (router?.history?.current?.name === 'trackandtrace/Shipment') {
                const currentClient = router.history.current.path.split('/')[1];
                router.push(`/${currentClient}/trackandtrace`);
            }
            state.message = i18n.t(`errors.${errno}`);
            state.display = true;
        } else {
            state.message = i18n.t(`errors.${errno}`);
            state.display = true;
        }
    },

    displayMessage(state, { color, message, timeout = 3000 }) {
        state.color = color;
        state.message = message;
        state.display = true;
        state.timeout = timeout;
    },
    closeErrors(state) {
        state.display = false;
        state.timeout = 0;
        state.color = 'pink';
    },
    setShowSnackBar(state, show) {
        state.showSnackbar = show;
    }
};

const actions = {};

export default {
    state,
    getters,
    actions,
    mutations
};
